module.exports = __webpack_public_path__ + "static/media/BreathAwareness25.04635c0c.mp3";